import type { JsonExchange } from '@skynet/data-shared-exchanges';

/**
 * Backend `Listen` sections that route sections map to (see `getListenSection`). Code that reacts
 * to a listen section (e.g. the accounts loader) must reference these, so a backend rename is one
 * edit here and a removed section is a compile error at every consumer.
 */
export const ListenSection = {
  Overview: 'overview',
  Balances: 'balances',
  Tasks: 'tasks',
  // Loans and retainers both listen to `terms`.
  Terms: 'terms',
  // The bots route listens to `trading`.
  // TODO: switch to 'bots' when the backend renames the section for that page.
  Trading: 'trading',
} as const;

/** A listen section the app maps a route to; `getListenSection` may also return exchange names. */
export type KnownListenSection = (typeof ListenSection)[keyof typeof ListenSection];

interface GetListenSectionParams {
  section?: string | null;
  exchange?: JsonExchange;
  defaultSection: string;
}

/**
 * Maps a route section to the backend `Listen` section. Unmapped sections pass through, or become
 * the exchange name when one is selected.
 */
export function getListenSection({
  section,
  exchange,
  defaultSection,
}: GetListenSectionParams): string {
  switch (section) {
    case 'bots':
      return ListenSection.Trading;
    case 'balances':
    case 'balances-admin':
      return ListenSection.Balances;
    case 'tasks':
    case 'tasks-admin':
      return ListenSection.Tasks;
    case 'overview-admin':
      return ListenSection.Overview;
    case 'terms':
    case 'terms-admin':
      return ListenSection.Terms;
    case null:
    case undefined:
    default:
      return exchange?.name ?? section ?? defaultSection;
  }
}
